const LAYOUTS = [];

export default LAYOUTS;
